import { TimeEntryType, TimeEntryView } from "../modules/typescript-trustapi-client/models";
import moment from 'moment';

declare module '@vue/runtime-core' {
  export interface ComponentCustomProperties {
    $getTimeEntryTypeName: (timeEntryTypeId: number, timeEntryType: TimeEntryType[]) => string,
    $getDetails: (timeEntry: TimeEntryView) => string,
    $getFirmName: (timeEntry: TimeEntryView) => string,
    $getReference: (timeEntry: TimeEntryView) => string,
    $getWorkHours: (timeEntry: TimeEntryView) => string,
    $getBreakHours: (timeEntry: TimeEntryView) => string,
    $calculateHours: (minutes: number) => string,
    $calculateHoursMins: (minutes: number) => string,
  }
}

export default {
  methods: {
    $getTimeEntryTypeName(timeEntryTypeId: number, timeEntryType: TimeEntryType[]): string {
      const singleTimeEntryType = timeEntryType.find(x => x.id === timeEntryTypeId)
      if (!singleTimeEntryType) {
        return ""
      }
      return singleTimeEntryType.name
    },
    $getDetails(timeEntry: TimeEntryView): string {
      if (timeEntry.timeEntryType.id === 1) {
        return timeEntry.timeEntryActivity.name;
      } else if (timeEntry.timeEntryType.id === 2) {
        return timeEntry.leaveType.name;
      } else {
        return ""
      }
    },
    $getFirmName(timeEntry: TimeEntryView): string {
      if (timeEntry.timeEntryType.id === 1 && timeEntry.investigation?.latestPracticeLogData) {
        return timeEntry.investigation?.latestPracticeLogData.firmName;
      } else {
        return ""
      }
    },
    $getReference(timeEntry: TimeEntryView): string {
      if (timeEntry.timeEntryType?.id === 1) {
        return timeEntry.investigation?.id;
      } else {
        return ""
      }
    },
    $getWorkHours(timeEntry: TimeEntryView): string {
      if (timeEntry.id === 0) {
        return ""
      } else if (timeEntry.timeEntryType.id === 1) {
        if (timeEntry.id === 0) {
          return ""
        } else if (timeEntry.workHours === 60) {
          return "1 Hour"
        } else {
          return this.$calculateHours(timeEntry.workHours);
        }

      } else if (timeEntry.timeEntryType.id === 2) {
        if (timeEntry.id === 0) {
          return ""
        } else if (timeEntry.leaveDuration === 60) {
          return "1 Hour"
        } else {
          return this.$calculateHours(timeEntry.leaveDuration);
        }
      } else {
        return ""
      }
    },
    $getBreakHours(timeEntry: TimeEntryView): string {
      if (timeEntry.id === 0) {
        return ""
      } else if (timeEntry.timeEntryType.id === 2) {
        return "00:00"
      } else {
        if (timeEntry.breakDuration === 60) {
          return "1 Hour"
        } else if (timeEntry.breakDuration === 0) {
          return "00:00"
        } else {
          return this.$calculateHours(timeEntry.breakDuration);
        }
      }
    },
    $calculateHours(minutes: number): string {
      if (minutes % 60 === 0) {
        if (minutes === 60) {
          return "1 Hour"
        } else {
          return minutes / 60 + " Hours"
        }
      } else {
        const duration = moment.duration(minutes, 'minutes');
        const hh = (duration.years() * (365 * 24)) + (duration.months() * (30 * 24)) + (duration.days() * 24) + (duration.hours());
        const mm = duration.minutes();
        if (hh === 0) {
          if (mm === 1) {
            return "1 Minute"
          }
          return mm + " Minutes";
        } else {
          if (hh === 1) {
            return hh + " Hour " + mm + " Minutes ";
          }
          return hh + " Hours " + mm + " Minutes ";
        }
      }
    },
    $calculateHoursMins(minutes: number): string {
      const numOfHrs = Math.floor(minutes / 60);
      const numOfMinsInDec = minutes % 60;
      return [
        (numOfHrs < 10 ? '0'+ numOfHrs : numOfHrs),
        (numOfMinsInDec < 10 ? '0'+ numOfMinsInDec : numOfMinsInDec)
      ].join(':');
    }
  }
};
